export default () => {
  const mobileNavigation = document.querySelector('.js-main-mobile-navigation');
  if (mobileNavigation) {
    const firstLevelItemsWithChildren = mobileNavigation.querySelectorAll('.Navigation__Item[data-level="0"][data-has-children="1"]');
    const secondLevelItemsWithChildren = mobileNavigation.querySelectorAll('.Navigation__Item[data-level="1"][data-has-children="1"]');
    // End of a branch: the parent levels call preventDefault() on the bubbling
    // click, so these navigate from here. Tabs with a single column are
    // collapsed on mobile, which can leave a leaf on level 1.
    const leafItems = mobileNavigation.querySelectorAll('.Navigation__Item[data-level="2"], .Navigation__Item[data-level="1"][data-has-children="0"]');
    const backLinks = document.querySelectorAll('.js-back-link');

    backLinks.forEach(backLink => {
      const anchorLink = backLink.querySelector('a.Link__Content');
      const icon = backLink.querySelector('span.Link__Icon');
      icon.addEventListener('click', el => {
        el.preventDefault();
        const closestBackLi = el.currentTarget.closest('.Navigation__Item--Back');
        closeMobilePanel(+closestBackLi.dataset.back + 1);
      });

      // if I click on the link, close the panel and go to the href if exists or is not #
      anchorLink.addEventListener('click', el => {
        el.preventDefault();
        const closestBackLi = el.currentTarget.closest('.Navigation__Item--Back');
        closeMobilePanel(+closestBackLi.dataset.back + 1);
        // get the href of the link
        const href = el.currentTarget.getAttribute('href');
        // navigate to the href if exists or is not #
        if (href && href.startsWith('#') === false) {
          window.location.href = href;
        }
      });
    })

    firstLevelItemsWithChildren && firstLevelItemsWithChildren.forEach(firstLevelItem => {
      firstLevelItem.addEventListener('click', el => {
        el.preventDefault();
        if (el.currentTarget.querySelector('.MobilePanel').classList.contains('is-open')) {
          return;
        }

        const MobileSubPanel = el.currentTarget.querySelector(`.MobilePanel[data-level="${+el.currentTarget.dataset.level + 1}"]`);
        MobileSubPanel.classList.add('is-open');
      });
    })

    secondLevelItemsWithChildren && secondLevelItemsWithChildren.forEach(secondLevelItem => {
      secondLevelItem.addEventListener('click', el =>  {
        el.preventDefault();
        if (el.currentTarget.querySelector('.MobilePanel').classList.contains('is-open')) {
          return;
        }
        const MobileSubPanel = el.currentTarget.querySelector(`.MobilePanel[data-level="${+el.currentTarget.dataset.level + 1}"]`);
        MobileSubPanel.classList.add('is-open');
      });
    })

    leafItems && leafItems.forEach(leafItem => {
      leafItem.addEventListener('click', el => {
        const anchorLink = el.currentTarget.querySelector('a.Link');
        const href = anchorLink.getAttribute('href');
        console.log(href);
        if (href) {
          window.location.href = href;
        }
      })
    })
    
  }
}

// close mobile panel according to the level
const closeMobilePanel = (level) => {
  setTimeout(() => {    
    const MobilePanels = document.querySelectorAll(`.MobilePanel[data-level="${level}"].is-open`);
    MobilePanels.forEach(MobilePanel => {
      MobilePanel.classList.remove('is-open');
    })
  }, 50);
}